import React from "react"
import {
    Box,
    useColors,
    componentStyles,
} from "@mallardbay/lib-react-components"

import { FeatureStatus as GeneratedFeatureStatus } from "~graphql/generated/types"

const FEATURE_STATUS_BETA = "beta"

export const FeatureStatus = {
    ...GeneratedFeatureStatus,
    Beta: FEATURE_STATUS_BETA,
} as const

export type FeatureStatusValue =
    (typeof FeatureStatus)[keyof typeof FeatureStatus]

interface Props {
    readonly featureStatus?: FeatureStatusValue | null
    readonly isRounded?: boolean
}

export default function FeatureStatusLabel({
    featureStatus,
    isRounded,
}: Props) {
    const styles = useStyles({ featureStatus, isRounded })

    if (!featureStatus) return null

    return <Box style={styles.box}>{featureStatus}</Box>
}

function useStyles({
    featureStatus,
    isRounded,
}: {
    featureStatus?: FeatureStatusValue | null
    isRounded?: boolean
}) {
    const colors = useColors()
    const backgroundColor = getBackgroundColor({ featureStatus, colors })

    return componentStyles({
        box: {
            backgroundColor,
            color: "white",
            fontSize: "10px",
            fontWeight: 1000,
            paddingX: "6px",
            paddingY: "2px",
            borderRadius: isRounded ? "full" : "4px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
    })
}

function getBackgroundColor({
    featureStatus,
    colors,
}: {
    featureStatus?: FeatureStatusValue | null
    colors: ReturnType<typeof useColors>
}) {
    switch (featureStatus) {
        case FeatureStatus.Preview:
            return colors.blue[400]
        case FeatureStatus.New:
        default:
            return colors.brandDefault
    }
}
